import { createAsyncThunk } from "@reduxjs/toolkit";
import { CompanyDataRequest, CompanyDataResponse } from "../../models/CompanyDataRequest.model";
import { environment } from "../../environments";

const API_URL = environment.apiUrl;

export const refreshCompanyData = createAsyncThunk<
  CompanyDataResponse,
  CompanyDataRequest,
  { rejectValue: string }
>("companyData/refresh", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Auth/company-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({Token: request.token, CompanyKey: request.companyKey}),
    });

    if (!response.ok) {
      return rejectWithValue("שגיאה בטעינת נתוני החברה");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return rejectWithValue("שגיאת רשת. נסה שוב מאוחר יותר.");
  }
});

